import { Stack, Text, Price } from "flicket-ui";
import pluralize from "pluralize";
import { Badge } from "~components";
import { HighDemandModalContentAffectedTicket } from "./HighDemandModalContent";

interface HighDemandModalTicketCardProps {
  ticket: HighDemandModalContentAffectedTicket;
  showFees: boolean;
  currency: string;
}
export function HighDemandModalTicketCard({
  ticket,
  showFees,
  currency,
}: HighDemandModalTicketCardProps) {
  return (
    <Stack
      direction="vertical"
      gap="1/2"
      backgroundColor="white"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="N200"
      borderRadius="md"
      padding={2}
    >
      <Stack direction="horizontal" gap={1} justifyContent="space-between">
        <Stack direction="vertical" gap="1/2">
          <Text variant="header.S">{ticket.name}</Text>
          <Text variant="regular">
            <Price price={ticket.price} currency={currency} />
            {showFees && ticket.fee > 0 && (
              <Text as="span" variant="small">
                {" "}
                + <Price price={ticket.fee} currency={currency} /> fee
              </Text>
            )}
          </Text>
          {ticket.customBadge && (
            <Badge
              color={ticket.customBadge.backgroundColor}
              textColor={ticket.customBadge.textColor}
              alignSelf="flex-start"
            >
              {ticket.customBadge.label}
            </Badge>
          )}
        </Stack>
        <Text variant="header.XS">
          x {pluralize("ticket", ticket.quantity, true)}
        </Text>
      </Stack>
    </Stack>
  );
}
